export const APP_VERSION = '920e33e';
